export default class SelectItem {
    constructor(item) {
        this.value = item.value
        this.label = item.label
    }
}
